import {
  Client,
  ClientSearchFilters,
  Pagination,
  ReferringDoctor,
  ShareFormsPayload,
} from '@nrwl/rx-models';

import { Action } from '@ngrx/store';
import { StickyNote } from '@nrwl/rx-models';

export enum ActiveClientsActionsTypes {
  LoadActiveClients = '[Clients] Load active clients ',
  LoadActiveClientsSuccess = '[Clients] Load active clients success',
  ResetActiveClients = '[Clients] Reset Active Clients ',

  LoadMoreActiveAclients = '[Clients] Load more active clients',
  LoadMoreActiveAclientsSuccess = '[Clients] Load more active clients success',

  LoadReferringDoctors = '[Clients] Load referring doctors',
  LoadReferringDoctorsSuccess = '[Clients] Load referring doctors success',

  CreateClient = '[Clients] Create a new client',
  CreateClientSuccess = '[Clients] Create a new client success',

  SelectedSort = '[Clients] selected sort',
  SetFilters = '[Clients] set filters',

  SetPassword = '[Clients] Set password for a client',
  SetPasswordSuccess = '[Clients] Set password for a client success',

  ShareForms = '[Clients] Share Via Portal',
  ShareViaPortalSuccess = '[Clients] Share Via Portal Success',

  ArchiveClient = '[Clients] Archive client',
  ArchiveClientSuccess = '[Clients] Archive client success',

  RestoreClient = '[Clients] Restore client',
  RestoreClientSuccess = '[Clients] Restore client success',

  DefineMergeableClients = '[Clients] Define mergeable clients',

  MergeClients = '[Clients] Merge clients',
  MergeClientsSuccess = '[Clients] Merge clients success',

  LoadStickyNote = '[Clients] Load Sticky Note',
  CreateStickyNote = '[Clients] Create Sticky Note',

  UpdateStickyNote = '[Clients] Update Sticky Note',
  ChangeStickyNoteSuccess = '[Clients] Change Sticky Note Success',

  SetSearchIn = '[Clients] Set Search In Value',

  ResetLoaderMore = '[Clients] Reset Loader More',
  Error = '[Clients] Error',
}

// #region load active clients
export class LoadActiveClients implements Action {
  readonly type = ActiveClientsActionsTypes.LoadActiveClients;
  constructor(
    public payload?: any,
    public forceRxSearch = false,
  ) {}
}

export class LoadActiveClientsSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.LoadActiveClientsSuccess;
  constructor(public payload: Pagination) {}
}

export class ResetActiveClients implements Action {
  readonly type = ActiveClientsActionsTypes.ResetActiveClients;
}
// #endregion

// #region load more active clients
export class LoadMoreActiveAclients implements Action {
  readonly type = ActiveClientsActionsTypes.LoadMoreActiveAclients;
}

export class LoadMoreActiveAclientsSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.LoadMoreActiveAclientsSuccess;
  constructor(public payload: any) {}
}
//#endregion

// #region load referring doctors
export class LoadReferringDoctors implements Action {
  readonly type = ActiveClientsActionsTypes.LoadReferringDoctors;
}

export class LoadReferringDoctorsSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.LoadReferringDoctorsSuccess;
  constructor(public payload: ReferringDoctor[]) {}
}
//#endregion

// #region create client
export class CreateClient implements Action {
  readonly type = ActiveClientsActionsTypes.CreateClient;
  constructor(public payload: { client: Client; redirect: boolean }) {}
}

export class CreateClientSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.CreateClientSuccess;
  constructor(public payload: Client) {}
}
//#endregion

// #region set password
export class SetPassword implements Action {
  readonly type = ActiveClientsActionsTypes.SetPassword;
  constructor(public payload: { id: number; password: string }) {}
}

export class SetPasswordSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.SetPasswordSuccess;
  constructor(public payload: Client) {}
}
//#endregion

// #region share via portal
export class ShareForms implements Action {
  readonly type = ActiveClientsActionsTypes.ShareForms;
  constructor(public payload: ShareFormsPayload) {}
}

export class ShareViaPortalSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.ShareViaPortalSuccess;
  constructor(public payload: any) {}
}
//#endregion

export class SelectedSort implements Action {
  readonly type = ActiveClientsActionsTypes.SelectedSort;
  constructor(public payload: string) {}
}

export class SetFilters implements Action {
  readonly type = ActiveClientsActionsTypes.SetFilters;
  constructor(public payload: ClientSearchFilters | null) {}
}
//#endregion

export class ArchiveClient implements Action {
  readonly type = ActiveClientsActionsTypes.ArchiveClient;
  constructor(public payload: Client) {}
}

export class ArchiveClientSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.ArchiveClientSuccess;
  constructor(public payload: Client) {}
}

export class RestoreClient implements Action {
  readonly type = ActiveClientsActionsTypes.RestoreClient;
  constructor(public payload: Client) {}
}

export class RestoreClientSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.RestoreClientSuccess;
  constructor(public payload: Client) {}
}

export class ResetLoaderMore implements Action {
  readonly type = ActiveClientsActionsTypes.ResetLoaderMore;
  constructor() {}
}

export class DefineMergeableClients implements Action {
  readonly type = ActiveClientsActionsTypes.DefineMergeableClients;
  constructor(public payload: Client[]) {}
}

export class MergeClients implements Action {
  readonly type = ActiveClientsActionsTypes.MergeClients;
  constructor(public payload: { target: number; sources: number[] }) {}
}

export class MergeClientsSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.MergeClientsSuccess;
  constructor(public payload: { target: number; sources: number[] }) {}
}

export class LoadStickyNote implements Action {
  readonly type = ActiveClientsActionsTypes.LoadStickyNote;
  constructor(public payload: number) {}
}

export class CreateStickyNote implements Action {
  readonly type = ActiveClientsActionsTypes.CreateStickyNote;
  constructor(public payload: { patient: number; note: string }) {}
}

export class UpdateStickyNote implements Action {
  readonly type = ActiveClientsActionsTypes.UpdateStickyNote;
  constructor(public payload: { stickyNoteId: number; data: { note: string } }) {}
}

export class ChangeStickyNoteSuccess implements Action {
  readonly type = ActiveClientsActionsTypes.ChangeStickyNoteSuccess;
  constructor(public payload: StickyNote) {}
}

export class SetSearchIn implements Action {
  readonly type = ActiveClientsActionsTypes.SetSearchIn;
  constructor(public payload: number) {}
}

// #region ERROR

export class Error implements Action {
  readonly type = ActiveClientsActionsTypes.Error;
  constructor(public payload: string) {}
}
// #endregion

export type ActiveClientsActions =
  | LoadActiveClients
  | LoadActiveClientsSuccess
  | ResetActiveClients
  | LoadMoreActiveAclients
  | LoadMoreActiveAclientsSuccess
  | LoadReferringDoctors
  | LoadReferringDoctorsSuccess
  | CreateClient
  | CreateClientSuccess
  | SetPassword
  | SetPasswordSuccess
  | ShareForms
  | ShareViaPortalSuccess
  | SelectedSort
  | SetFilters
  | ArchiveClient
  | ArchiveClientSuccess
  | RestoreClient
  | RestoreClientSuccess
  | DefineMergeableClients
  | SetSearchIn
  | MergeClients
  | MergeClientsSuccess
  | LoadStickyNote
  | ChangeStickyNoteSuccess
  | ResetLoaderMore
  | Error;
